import { Plus } from "lucide-react";
import { useState } from "react";

import { Eyebrow, Section, sectionTitle } from "@/features/platform/components/landing-ui";
import { questions } from "@/features/platform/content/landing";
import { cn } from "@/lib/utils";
import { m } from "@/paraglide/messages.js";

/**
 * What trainers ask before moving their week here. An intro column on the left and an accordion
 * on the right; one row open at a time, and the open row picks up the soft wash.
 */
export const PlatformQuestions = () => {
  const [open, setOpen] = useState(0);

  return (
    <Section id="questions">
      <div className="grid gap-10 md:grid-cols-[1fr_1.5fr]">
        <div className="px-1">
          <Eyebrow>{m.platform_questions_title()}</Eyebrow>
          <h2 className={cn(sectionTitle, "mt-4")}>
            {m.platform_questions_heading_one()}
            <br />
            {m.platform_questions_heading_two()}
          </h2>
          <p className="mt-4 max-w-[320px] text-muted-foreground">{m.platform_questions_aside()}</p>
        </div>

        <div className="flex flex-col gap-2.5">
          {questions.map((item, index) => {
            const isOpen = open === index;
            return (
              <div
                key={item.id}
                className={cn("rounded-[22px] transition-colors", isOpen ? "bg-[var(--site-wash)]" : "bg-card")}
              >
                <button
                  type="button"
                  onClick={() => setOpen(isOpen ? -1 : index)}
                  aria-expanded={isOpen}
                  className="flex w-full items-center justify-between gap-4 px-6 py-5 text-left text-base font-medium"
                >
                  {item.question()}
                  <span className="grid size-8 shrink-0 place-items-center rounded-full bg-primary text-primary-foreground">
                    <Plus className={cn("size-4 transition-transform duration-[250ms]", isOpen && "rotate-45")} />
                  </span>
                </button>
                {isOpen ? (
                  <div className="max-w-[560px] px-6 pb-5 text-[15px] leading-relaxed text-muted-foreground">
                    {item.answer()}
                  </div>
                ) : null}
              </div>
            );
          })}
        </div>
      </div>
    </Section>
  );
};
